import PropTypes from 'prop-types';
import { constants } from '../../../config/constants';
import { noop } from '../../../utils/noop';
import { truncateText, ucFirst } from '../../../utils/textHelper';
import { styles } from './FacetWithMiniPods.style';

export const FacetWithMiniPods = ({ item, onFacetChange }) => {
  const renderMiniPods = () => {
    return item.values.map((value) => {
      const { title, url } = value;
      return (
        <div className="pods">
          <button
            type="button"
            className="facet-with-mini-pods"
            id={`testId-facetWithMiniPods-${title}`}
            onClick={() => {
              onFacetChange(url, value);
            }}
          >
            {ucFirst(truncateText(title, constants.FACETS.VALUE_TEXT_CHARCOUNT, true))}
          </button>
          <style jsx>{styles}</style>
        </div>
      );
    });
  };
  const facetType = (item?.values?.[0]?.filters || []).find((f) => /_category_paths/.test(f?.name))?.name || '';
  return (
    <div className="pods-container" data-facet-type={facetType}>
      {renderMiniPods()} <style jsx>{styles}</style>
    </div>
  );
};

FacetWithMiniPods.defaultProps = {
  onFacetChange: noop,
};

FacetWithMiniPods.propTypes = {
  item: PropTypes.object.isRequired,
  onFacetChange: PropTypes.func,
};
